import ApiService from './api.service'

class EventService extends ApiService<TEvent> {
  constructor() {
    super({ basePath: '/events' })
  }
}

export default new EventService()
